export default "__VITE_ASSET__a9dbadc8__"